import { Form } from "formik";
import React from "react";
import * as yup from "yup";

import Button from "@/components/UI/Button";
import { CustomForm } from "@/component-library";
import FormikInput from "@/components/UI/FormikInput";
import { mergeObjectOnlyExistingFields } from "@/utils/objectUtils";
import {
  PREFERRED_NAME_SCHEMA_PATIENT,
  PREFERRED_PRONOUNS_SCHEMA,
} from "@/containers/Dashboard/Patient/schema/PatientProfileInfoSchema";

import { COMPLETE_PROFILE_STEPS } from "./CompleteProfileWidget";

export const CompletePreferredName = (props) => {
  const { closeModal, profile, setCurrentCompleteProfileStep, submitHandler } = props;

  const renderForm = (formikProps) => {
    const formikInputProps = {
      errors: formikProps.errors,
      touched: formikProps.touched,
    };

    return (
      <Form>
        <div className="mx-auto px-0 mb-3">
          <div className="px-0 row pb-5">
            <div className="col-12">
              <FormikInput
                key={PREFERRED_NAME_SCHEMA_PATIENT.name}
                {...formikInputProps}
                formEl={PREFERRED_NAME_SCHEMA_PATIENT}
              />
            </div>
            <div className="col-12">
              <FormikInput
                key={PREFERRED_PRONOUNS_SCHEMA.name}
                {...formikInputProps}
                formEl={PREFERRED_PRONOUNS_SCHEMA}
              />
            </div>
          </div>
          <div className="px-0 row">
            <div className="d-flex w-100 tw:justify-center">
              <Button
                className="Btn Btn--otl-pri self-signup-btn m-auto"
                onClick={() =>
                  setCurrentCompleteProfileStep(COMPLETE_PROFILE_STEPS.EMERGENCY_CONTACT)
                }
                type="submit"
              >
                Back
              </Button>
              <Button className="Btn Btn--pri self-signup-btn m-auto" type="submit">
                Save
              </Button>
            </div>
          </div>
        </div>
      </Form>
    );
  };

  return (
    <>
      <CustomForm
        initialValues={mergeObjectOnlyExistingFields(ADDRESS_INITIAL_VALUES, profile)}
        onSubmit={(formData, actions) => {
          submitHandler(formData, actions);
          closeModal();
        }}
        render={renderForm}
        validationSchema={preferredNameSchema}
      />
    </>
  );
};

const ADDRESS_INITIAL_VALUES = {
  preferred_name: "",
  preferred_pronouns: "",
  username: "",
};

const preferredNameSchema = yup.object().shape({
  preferred_name: yup
    .string()
    .matches(/^[a-zA-Z-]+$/, "Numerals, spaces & special characters are not allowed")
    .nullable(),
  preferred_pronouns: yup.string().nullable(),
});
